import React, { CSSProperties } from 'react';

const ApplicationConfirmation = (props: {languageId: string}) => {
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      padding: '20px',
      boxSizing: 'border-box',
      backgroundColor: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
    },
    card: {
      width: '100%',
      maxWidth: '500px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
      padding: '40px',
      textAlign: 'center',
      transition: 'transform 0.3s ease',
    },
    cardHover: {
      transform: 'translateY(-5px)'
    },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '25px',
      color: '#4CAF50'
    },
    heading: {
      color: '#333',
      fontSize: '24px',
      marginBottom: '15px',
      fontWeight: 'bold'
    },
    mainText: {
      color: '#666',
      fontSize: '18px',
      lineHeight: 1.6,
      marginBottom: '25px'
    },
    footer: {
      borderTop: '1px solid #eaeaea',
      paddingTop: '20px',
      marginTop: '20px'
    },
    footerText: {
      color: '#999',
      fontSize: '14px'
    }
  };

  return (
    <div style={styles.container as CSSProperties}>
      <div style={styles.card as CSSProperties}>
        <div style={styles.icon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        <div>
          <h2 style={styles.heading}>
            {props.languageId === '1'
              ? 'Application Submitted'
              : 'Solicitud Enviada'
              }
          </h2>
          <p style={styles.mainText}>
            {props.languageId === '1'
              ? 'Thank you for submitting your application. You will be contacted shortly.' 
              : 'Gracias por enviar su solicitud. Nos pondremos en contacto con usted en breve.'}
          </p>
        </div>
        <div style={styles.footer}>
          <p style={styles.footerText}>
            {props.languageId === '1'
              ? 'We appreciate your interest and will review your application soon.'
              : 'Agradecemos su interés y revisaremos su solicitud pronto.'
            }            
          </p>
        </div>
      </div>
    </div>
  );
};

export default ApplicationConfirmation;